"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORTS : CONTROLS : STYLES --------------- ++++++++++ */


var _default = {
  controls: {
    display: 'flex',
    width: 'fit-content',
    borderRadius: "".concat((0, _index.pxToEm)(5)),
    boxShadow: _index.theme.boxShadow.small
  }
};
exports.default = _default;